<template>
    <div>
        <!-- 指派 -->
        <el-form ref="form" :model="form" label-width="80px" class="event-form" :rules="rules">
            <el-form-item label="下一节点" v-if="type!='转交'&&type!='回顾并关闭'&&type!='发布完成'&&type!='驳回'">
                <el-input v-model="this.form.handle" disabled></el-input>
            </el-form-item>
            <el-form-item :label="type=='CAB评审'?'CAB处理组':'处理组'" v-if="type!='回顾并关闭'&&type!='发布完成'&&type!='驳回'" >
                <div class="el-form__inline">
                    <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                        <el-option v-for="item in departmentList" :key="item.id" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                    <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
                </div>
            </el-form-item>

            <el-form-item label="处理人" v-if="type!='回顾并关闭'&&type!='发布完成'&&type!='驳回'">
                <div class="el-form__inline">
                    <el-input v-model="form.currentHandler" disabled></el-input>
                    <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                    <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                </div>
            </el-form-item>
            <el-form-item label="处理意见" >
                <el-input type="textarea" v-model="form.handleComment"></el-input>
            </el-form-item>
            <el-form-item v-if="this.type=='实施完成'" >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上传附件">
                            <input style="font-size: 12px" type="file" @change="fileChange">
                            <span>文件小于等于15MB</span>
                        </el-form-item>
                        <div v-for="(item ,i) in attachment" :key="i">{{ item.name }}</div>
                    </el-col>
                </el-row>
            </el-form-item>

            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import departmentFrame from "../../components/departmentFrame.vue";
    import services from "../../services/common.service"
    import commonService from "../../services/common.service"
    import notifyTab from "../common/notifyTab.vue"
    import {getRules} from "../problemManage/problem.rules";
    const rules=getRules()
    export default {
        props:{
            serialNumber:String,
            callback:Function,
            type:{
                type:String,
                default:""
            },
            problemTag: Boolean
        },
        components:{ departmentFrame,notifyTab },
        data() {
            return {
                rules:rules,
                form:{
                    currentDepartment:"",
                    handle:"",
                    currentHandler:'',
                    opinion:"",
                    notify:[]
                },
                notifyUserid:[],
                departmentList:[],      // 处理组
                requesterInfo:{},
                currentDepartment:{},   // 选择的部门信息
                currentUserId:[],       // 选择的人员ID
                currentUserName:[],
                dis_user:true,
                modelTit:"",           // 页面标题
                attachment:"",        //上传附件
                busynessUserbtn:true,
                groupTasksTotal:'',   //组任务数
                userTasksTotal:'',    //人员任务数量
                isSubmit:false,
            }
        },
        created() {
            this.getDepartment();
            this.$modal.title = this.type;
            if(this.type == "转一线"){
                this.form.handle = "一线"
            };
            if(this.type == "转二线"){
                this.form.handle = "二线"
            };
            if(this.type == "转三线"){
                this.form.handle = "三线"
            };
            if(this.type == "转第三方"){
                this.form.handle = "第三方"
            };
            if(this.type=='驳回'){
                this.form.handle = "驳回"
            }
            //来自问题管理的变更操作
            if(this.type == "变更操作"){
                this.form.handle = "变更流程"
            };

        },
        methods: {
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                services.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                })
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                this.requesterInfo = {
                    id:"",
                    name:"",
                };
                this.form.currentHandler = "";
                this.userTasksTotal= '';
                this.busynessUserbtn = this.requesterInfo.id ? false : true;
                let groupId=this.form.currentDepartment
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            submit(){
                this.isSubmit=true
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let params = {
                    serialNumber:this.serialNumber,
                    handle:this.type,
                    currentDepartment:this.form.currentDepartment,
                    currentHandler:this.requesterInfo.id,
                    handleComment:this.form.handleComment,
                    notify:this.notifyUserid
                }
                if (!params.currentDepartment&&this.type!='驳回'){
                    this.isSubmit=false
                    this.$message.error('请选择处理组')
                } else if(this.type!='回顾并关闭'&&this.type!='发布完成'&&this.type!='驳回'&&!this.form.currentHandler){
                    this.isSubmit=false
                    this.$message.error('请选择处理人')
                }else if(!this.form.handleComment){
                    this.isSubmit=false
                    this.$message.error('请填写处理意见')
                }else {
                    if (this.problemTag===true){
                        services.problemHandle(params).then(res => {
                            this.$message.success(this.type+"成功");
                            this.close(true);
                        }).catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message);
                        })
                    } else {
                        services.eventHandle(params).then(res => {
                            this.$message.success(this.type+"成功");
                            this.close(true);
                        }).catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message);
                        })
                    }
                }


            },
            // 组员页面
            toRequesterList(){
                let id = this.form.currentDepartment.toString();
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:id
                    }
                })
            },
            getRequester(obj){
                this.requesterInfo = {
                    id:obj.internalUserid,
                    name:obj.name,
                };
                this.form.currentHandler = obj.name;
                this.busynessUserbtn = obj.internalUserid ? false : true;
                let userid=this.requesterInfo.id
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },


            //上传文件
            fileChange(e){
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length){
                    return;
                };
                this.form.attachment = files[0];
                let params = {
                    file_name:files[0]
                };
                commonService.uploading(params).then(res => {
                    let file =  res.file_data;
                    this.attachment.push({
                        name:file.file_name,
                        url:file.download_url
                    })
                }).catch( err => {
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }

        }
    }
</script>


<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }

</style>
